import { INavRoute } from 'app/components/navigation/Nav/interfaces'
import { NavItem } from 'app/components/navigation/NavItem'
import * as Headroom from 'headroom.js'
import { History } from 'history'
import * as React from 'react'
import * as ListGroup from 'react-bootstrap/lib/ListGroup'
import * as NavDropdown from 'react-bootstrap/lib/NavDropdown'
import { NavLink } from 'react-router-dom'

const tabletBreakpoint = 1200

interface INavProps {
  config: INavRoute[]
  history?: History
  noLeftNav?: boolean
}

interface INavState {
  showNav: boolean
}

class Nav extends React.Component<INavProps, INavState> {

  state = {
    showNav: false
  }

  unlisten: () => void
  headroom: Headroom

  componentDidMount() {
    //Remove showNav when link is clicked
    if (this.props.history) {
      this.unlisten = this.props.history.listen(() => {
        this.setState({ showNav: false })
        window.scrollTo(-64, 0)
      })
    }

    this.headroom = new Headroom(document.querySelector('.header'), {
      offset: 64,
      tolerance: 10,
      classes: { initial: 'animated', pinned: 'slideInDown', unpinned: 'slideOutUp' },
    })

    this.headroom.init() //Auto-hide header
  }

  componentWillUnmount() {
    if (typeof this.unlisten === 'function') {
      this.unlisten()
    }
  }

  showNavToggle() {
    const { showNav } = this.state
    this.setState({ showNav: !showNav })
  }

  mapNavRouteToNavItem(config: INavRoute, index: number) {
    if (this.props.noLeftNav) {
      if (config.multi) {
        return (
          <NavDropdown id="navDropDown" key={index} title={config.multi.name}>
            {config.multi.routes.map((route, index) =>
              <li key={route.path + index}>
                <NavLink exact to={route.path} onClick={() => this.showNavToggle()} >
                  {route.name}
                </NavLink>
              </li>
            )}
          </NavDropdown>
        )
      } else {
        return (
          <li key={index}>
            <NavLink exact to={config.single.path} onClick={() => this.showNavToggle()}>
              <i className={config.single.iconClass}></i>&nbsp;
              {config.single.name}
            </NavLink>
          </li>
        )
      }
    } else {
      if (config.multi) {
        return (
          <NavItem key={index} history={this.props.history} multiConfig={config.multi} />
        )
      } else if (config.single) {
        return (
          <NavItem key={index} history={this.props.history} singleConfig={config.single} />
        )
      }
    }
  }

  render() {
    const navRoutes = this.props.config
      .filter((config) => config.hidden !== true)
      .map((config, index) => this.mapNavRouteToNavItem(config, index))

    const navClasses = this.state.showNav ? 'show-nav' : ''
    let headerClasses = 'navbar navbar-inverse navbar-fixed-top header'

    if (this.props.noLeftNav !== true) {
      headerClasses += ' hideWhenNotCollapsed'
    }

    return (
      <nav className={navClasses}>
        <header className={headerClasses}>
          <div className="container">
            {this.props.noLeftNav ?
              <section>
                <div className="navbar-header">
                  <button type="button" className="navbar-hamburger" onClick={() => this.showNavToggle()} />

                  <a className="navbar-brand" href="#" style={{ padding: '10px 10px' }}>
                    <img height="60" alt="Brand" src="/assets/img/logo-sm.png" />
                  </a>
                </div>

                <div className="collapse navbar-collapse">
                  <ul className="nav navbar-nav navbar-right">
                    {navRoutes}
                  </ul>
                </div>
              </section>
              :
              <section>
                <a className="navbar-brand" href="#">
                  <img height="30" alt="Brand" src="/assets/img/logo-sm.png" />
                </a>

                <button type="button" className="navbar-hamburger" onClick={() => this.showNavToggle()} />
              </section>
            }
          </div>
        </header>

        {this.props.noLeftNav ?
          null :
          <aside className="left-nav">
            <div className="left-brand">
              <img className="img-responsive hideOnCollapsed" alt="Brand" src="/assets/img/logo.png" />
            </div>

            <ListGroup className="list-group-clear">
              {navRoutes}
            </ListGroup>
          </aside>
        }
      </nav>
    )
  }
}

export {
  Nav,
  INavState
}



// WEBPACK FOOTER //
// ./src/app/components/navigation/Nav/index.tsx